import { BrowserRouter, Routes, Route } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage.tsx';
import BuilderPage from './pages/BuilderPage.tsx';
import LoginPage from './pages/LoginPage.tsx';
import PublicFormPage from './pages/PublicFormPage.tsx';
import AuthGuard from './components/AuthGuard.tsx';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {/* Publish share link — intentionally NOT wrapped in AuthGuard, anyone with the link can fill it in */}
        <Route path="/f/:id" element={<PublicFormPage />} />
        <Route
          path="/"
          element={
            <AuthGuard>
              <DashboardPage />
            </AuthGuard>
          }
        />
        <Route
          path="/builder"
          element={
            <AuthGuard>
              <BuilderPage />
            </AuthGuard>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
